import { render, staticRenderFns } from "./SlimTakeInStatus.vue?vue&type=template&id=61c3aafc&scoped=true&"
import script from "./SlimTakeInStatus.vue?vue&type=script&lang=js&"
export * from "./SlimTakeInStatus.vue?vue&type=script&lang=js&"
import style0 from "./SlimTakeInStatus.vue?vue&type=style&index=0&id=61c3aafc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c3aafc",
  null
  
)

export default component.exports